export default __webpack_public_path__ + "883330ab13d9f085577ffa435e0aee96.svg";